import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { Main, PageLoader } from "components";
import { Button } from "expano-components";

import {
  Price,
  Specification,
  ProductImages,
  Alias,
  ExportPanel,
  ProductCard,
  PlatformTaxons,
} from "./panels";
import {
  getProductGroup,
  resetProductGroup,
  generateGalleryForAllChannelProductGroups,
} from "actions/product_group";

import { ReactComponent as ProductIcon } from "icons/product.svg";

const Panels = ({ tab, product_group_id }) => {
  switch (tab) {
    case "specification":
      return <Specification />;
    case "price":
      return <Price />;
    case "images":
      return <ProductImages />;
    case "aliases":
      return <Alias />;
    case "product_cards":
      return <ProductCard />;
    case "statuses":
      return <ExportPanel />;
    case "platform_taxons":
      return <PlatformTaxons />;
    default: {
      return (
        <Redirect
          to={`/products_manage/product_groups/${product_group_id}/specification`}
        />
      );
    }
  }
};

const EditProductGroup = ({
  product_group,
  history,
  match: {
    params: { product_group_id, tab },
  },
  getProductGroup,
  resetProductGroup,
  generateGalleryForAllChannelProductGroups,
}) => {
  const [is_generating_gallery, setGeneratingGallery] = useState(false);
  const tabs = [
    {
      id: "specification",
      name: "Specyfikacja",
    },
    {
      id: "price",
      name: "Ceny",
    },
    {
      id: "product_cards",
      name: "Karty produktowe",
    },
    {
      id: "images",
      name: "Baza zdjęć",
    },
    {
      id: "platform_taxons",
      name: "Kategorie",
    },
    {
      id: "aliases",
      name: "Aliasy",
    },
    {
      id: "statuses",
      name: "Statusy",
    },
  ].filter(Boolean);

  useEffect(() => {
    getProductGroup(product_group_id);
    return () => resetProductGroup();
  }, [product_group_id]);

  if (["invalid", "loading", "failure"].includes(product_group.status)) {
    return <PageLoader />;
  }

  const { data } = product_group;

  const handleGenerateGalleryForAllChannelProductGroups = async () => {
    try {
      setGeneratingGallery(true);
      await generateGalleryForAllChannelProductGroups(product_group_id);
    } catch (error) {
    } finally {
      setGeneratingGallery(false);
    }
  };

  return (
    <Main
      page={{
        name: `${data?.name} [${data?.producer?.name || "-"}]`,
        icon: <ProductIcon />,
        breadcrumbs: [
          {
            name: "Zarządzanie produktami",
            path: "/products_manage",
          },
          { name: data?.sku },
        ],
        buttons: (
          <>
            {tab === "product_cards" && (
              <Button
                type="add"
                disabled={is_generating_gallery}
                text={
                  is_generating_gallery
                    ? "Proszę czekać..."
                    : "Wygeneruj galerię i zdjęcia sekcji dla wszystkich kanałów"
                }
                onClick={handleGenerateGalleryForAllChannelProductGroups}
              />
            )}
          </>
        ),
      }}
    >
      <ul className="main-tabs">
        {tabs.map(({ id, name }) => (
          <li
            key={id}
            className={`tab dashboard-tab-text ${id === tab ? "active" : ""}`}
            onClick={() =>
              history.push(
                `/products_manage/product_groups/${product_group_id}/${id}`
              )
            }
          >
            {name}
          </li>
        ))}
      </ul>
      <Panels
        {...{
          product_group_id,
          tab,
        }}
      />
    </Main>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getProductGroup: (id) => dispatch(getProductGroup(id)),
  resetProductGroup: () => dispatch(resetProductGroup()),
  generateGalleryForAllChannelProductGroups: (id) =>
    dispatch(generateGalleryForAllChannelProductGroups(id)),
});

export default connect(
  ({ product_group }) => ({
    product_group,
  }),
  mapDispatchToProps
)(EditProductGroup);
